import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@wondermaps/ui";

interface FunnelItem {
  poiId: string;
  poiName: string;
  selects: number;
  engagements: number;
  navigations: number;
  selectToEngageRate: number;
  engageToNavRate: number;
}

export function EngagementFunnel({
  data,
  outboundClicksTotal,
}: {
  data: FunnelItem[];
  outboundClicksTotal: number;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Engagement Funnel (per POI)</CardTitle>
        <CardDescription>
          Shows the 3-step visitor journey for each POI: Select (tap on map
          or list) → Engage (view content/dwell) → Navigate (request
          directions). Drop-off percentages reveal where visitors lose
          interest. Outbound clicks are shown separately as they aren't
          tied to individual POIs.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {data.length === 0 ? (
          <p className="text-muted-foreground">No funnel data in this period.</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>POI</TableHead>
                <TableHead className="text-right">Selects</TableHead>
                <TableHead className="text-right">Engagements</TableHead>
                <TableHead className="text-right">Drop-off</TableHead>
                <TableHead className="text-right">Navigations</TableHead>
                <TableHead className="text-right">Drop-off</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((item) => (
                <TableRow key={item.poiId}>
                  <TableCell className="font-medium">{item.poiName}</TableCell>
                  <TableCell className="text-right">{item.selects.toLocaleString()}</TableCell>
                  <TableCell className="text-right">{item.engagements.toLocaleString()}</TableCell>
                  <TableCell className="text-right text-muted-foreground">
                    {item.selectToEngageRate}%
                  </TableCell>
                  <TableCell className="text-right">{item.navigations.toLocaleString()}</TableCell>
                  <TableCell className="text-right text-muted-foreground">
                    {item.engageToNavRate}%
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <div className="rounded-lg border p-3 text-center">
          <p className="text-2xl font-bold">{outboundClicksTotal.toLocaleString()}</p>
          <p className="text-xs text-muted-foreground">
            Total Outbound Clicks (org-wide, not per-POI)
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
